import React, { Component } from 'react';
// import axios from 'axios';
// import NumberFormat from 'react-number-format';
// import { Redirect } from 'react-router-dom';
// import './Faqs.scss'
// import {Link} from 'react-router-dom'
// import Icon from 'react-icons-kit';
// import { arrowLeft } from 'react-icons-kit/fa/arrowLeft';
// import { trash } from 'react-icons-kit/fa/trash';
// import { ToastContainer, toast } from 'react-toastify';
// import visamastercard from './../../../images/visa-mastercard.png';

class Faq extends Component {
   constructor(props) {
      super(props);
      this.state = {
         loaderButton : false,
         loggedIn: false,
         loading:true,
         statusUser:false,
      };
   }

      
   componentDidMount() {
   }
   
   
   render() {
      return (
         <div className="mpl-page cp-85">
            <div className="container">
               <div className="row">
                  <div className="col-sm-12">
                     <div className="page-wrapper">
                        <h1 className="page-title text-center">
                           Frequently Asked Questions
                        </h1>
                        <div className="page-content mt-5">
                           <h3 className="text-semi">Apa itu jejak karbon?</h3>
                           <p>
                           Aktivitas yang kita lakukan sehari-hari menghasilkan akumulasi emisi gas rumah kaca berupa karbon dioksida dan emisi polutan lainnya. Ini adalah jejak karbon. Jejak karbon yang berlebih berdampak negatif pada kehidupan kita, seperti mendorong terjadinya krisis iklim serta penurunan kualitas udara. 
                           </p>
                           <br/>

                           <h3 className="text-semi">Apa itu <i>carbon offset</i></h3>
                           <p>
                           Carbon offset adalah upaya penyerapan jejak karbon yang kita hasilkan, demi mengurangi dampak buruknya pada iklim. Salah satu upaya penyerapan jejak karbon adalah dengan penanaman pohon baru
                           </p>
                           <br/>

                           <h3 className="text-semi">Bagaimana pohon bantu serap jejak karbon?</h3>
                           <p>
                           Pohon berperan penting dalam penyerapan emisi karbon dioksida dari atmosfer, juga pelepasan kembali oksigen ke alam. Penambahan jumlah pohon baru juga memperluas ruang hijau yang vital bagi kualitas udara, dan dalam mengurangi dampak krisis iklim.
                           </p>
                           <br/>

                           <h3 className="text-semi">Bagaimana cara saya menyerap jejak karbon yang saya hasilkan?</h3>
                           <p>
                           GoGreener: carbon offset memudahkan kamu untuk menyerap jejak karbon tersebut dengan menanam pohon. Dengan teknologi Gojek dan Jejak.in, kegiatan penanaman pohon untuk carbon offset dapat dilakukan dengan mudah, transparan, serta berkelanjutan. Cukup dengan masuk ke aplikasi Gojek, memilih shuffle card Jejak.in dari halaman utama, kamu bisa menghitung jejak karbon yang kamu hasilkan setiap harinya dan membeli pohon untuk penyerapan jejak karbon tersebut. 
                           </p>
                           <br/>

                           <h3 className="text-semi">Siapa yang akan menanam pohon saya? </h3>
                           <p>
                           Dana yang terkumpul akan dibelikan pohon mangrove untuk ditanam oleh mitra konservasi Gojek dan Jejak.in, yaitu LindungiHutan. Penanaman ini akan dilakukan di kawasan konservasi yang disepakati bersama. 
                           </p>
                           <br/>

                           <h3 className="text-semi">Di mana pohon saya akan ditanam? </h3>
                           <p>
                           Di periode pertama, pohon kamu akan ditanam di kawasan Pantai Indah Kapuk, DKI Jakarta. Ke depannya, Gojek juga akan terus mendukung upaya-upaya sadar lingkungan lainnya, sehingga di fase selanjutnya, kamu dapat melakukan aksi carbon offset lainnya. 
                           </p>
                           <br/>

                           <h3 className="text-semi">Pohon apa yang akan ditanam?  </h3>
                           <p>
                           Di periode pertama, kita akan menanam pohon mangrove di kawasan Pantai Indah Kapuk, DKI Jakarta. 
                           </p>
                           <br/>

                           <h3 className="text-semi">Mengapa menanam tanaman mangrove?  </h3>
                           <p>
                           Tanaman mangrove dapat memberi dampak positif terhadap lingkungan dan kehidupan kita karena dapat menyerap karbon dalam jumlah besar, melindungi daerah pesisir dari abrasi air laut, serta menjadi rumah bagi berbagai ekosistem darat dan laut.  
                           </p>
                           <br/>

                           <h3 className="text-semi">Bagaimana proses GoGreener: carbon offset ini berjalan? </h3>
                           <p>
                           Kegiatan GoGreener ini akan dibagi menjadi beberapa fase, pada fase awal, Gojek mengajak kamu menyerap jejak karbonmu dengan menambah jumlah pohon di lingkungan sekitar kita. Pada periode pertama, pohon yang terkumpul akan ditanam di kawasan Pantai Indah Kapuk, DKI Jakarta. Gojek juga akan terus mendukung upaya-upaya sadar lingkungan lainnya, sehingga di fase selanjutnya, kamu dapat melakukan aksi carbon offset lainnya. 
                           </p>
                           <br/>

                           <h3 className="text-semi">Apakah pohon yang saya tanam akan dijaga? </h3>
                           <p>
                           Pohon yang telah terkumpul dan ditanam akan dijaga melalui proses pemantauan yang dilakukan oleh Mitra Konservasi Gojek dan Jejak.in, yaitu Lindungi Hutan, di kawasan konservasi yang disepakati bersama. Pemantauan penanaman dan pertumbuhan pohon akan dilakukan menggunakan sistem pemantauan dari Jejak.in yang dapat diakses kapan saja melalui link yang tertera pada email. Link tersebut akan dikirimkan 3 bulan setelah batch pertama terkumpul.  
                           </p>
                           <br/>

                           <h3 className="text-semi">Bagaimana cara mengetahui perkembangan pohon saya? </h3>
                           <p>
                           Jejak.in akan mengirimkan laporan monitoring and evaluation kepada kamu setiap bulan ke alamat email yang kamu gunakan di aplikasi Gojek. Di laporan ini, kamu dapat mengetahui lokasi penanaman dan informasi lebih lanjut tentang pohon yang kamu tanam, seperti status pohon, tinggi pohon, warna daun, diameter batang utama, kondisi batang utama, dan foto pohon. 
                           </p>
                           <br/>

                           <h3 className="text-semi">Bagaimana cara hutan untuk dapat menyerap gas karbon di permukaan bumi? </h3>
                           <p>
                           Cadangan Karbon yang diserap oleh hutan disimpan oleh tiga komponen pokok yaitu, Biomassa (Bagian Hidup) seperti pohon, Nekromasa (Bagian Mati) seperti batang pohon yang masih tegak maupun telah tumbang di permukaan lahan, dan Organik (Tanah). 
                           </p>
                           <p>
                           Ketiga komponen ini dapat menjadi sumber stok karbon bagi bumi. Jejak.in berfokus pada perhitungan kemampuan "biomassa pohon” untuk menyerap karbon. 
                           </p>
                           <br/>

                           <h3 className="text-semi">Bagaimana cara mengetahui variasi spesies pada pohon?  </h3>
                           <p>
                           Berat Jenis Pohon, Setiap pohon memiliki berat jenis yang bervariasi, tergantung dengan jenis pohonnya. Jejak.in memperoleh data dari ICRAF, sebuah Lembaga yang telah melakukan survei lapangan untuk mengetahui berat jenis seluruh spesies pohon-pohon yang ada di Indonesia
                           </p>
                           <br/>

                           <h3 className="text-semi">Metode apa yang digunakan untuk menghitung jejak karbon? </h3>
                           <p>
                           Dalam menghitung jejak karbon, Jejak.in menggunakan metode yang direkomendasikan oleh IPCC (Intergovernmental Panel on Climate Change), dimana perumusannya telah disesuaikan oleh WRI Indonesia melalui fasilitasi expert peer reviews. WRI Indonesia adalah sebuah lembaga kajian independen yang fokus pada pembangunan sosio-ekonomi nasional secara inklusif dan berkelanjutan. Beberapa parameter yang dibutuhkan dalam metode ini di antaranya:
                           </p>
                           <ul>
                              <li>
                                 Jarak tempuh
                              </li>
                              <li>
                                 Konsumsi bahan bakar
                              </li>
                              <li>
                                 Faktor emisi
                              </li>
                           </ul>

                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         )
      }
   }
   export default Faq;